// Base address of the APMERCL backend, baked in at build time from REACT_APP_BACKEND_URL.
//
// Every call site must go through apiUrl() so that an unset variable yields no URL at all
// instead of a broken one — see lib/env.js for why an unset variable is dangerous rather
// than merely absent.

import { envUrl } from "./env";

// envUrl() already strips trailing slashes, so `${API_BASE}/api/x` can never become `//api/x`.
export const API_BASE = envUrl(process.env.REACT_APP_BACKEND_URL);

export const hasApi = () => API_BASE !== "";

// Returns the full URL, or null when no backend is configured. Callers must handle null.
export const apiUrl = (path) => (hasApi() ? `${API_BASE}${path}` : null);

export const NO_BACKEND_MESSAGE =
  "The APMERCL server is not connected yet, so this cannot be completed online.";

export const SIGNIN_DISCONNECTED =
  "Sign-in service is not connected. Department login will work after the APMERCL server is hosted.";

export const authHeaders = () => {
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("apmercl_token") : "";
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const SESSION_EXPIRED_MESSAGE = "Session expired. Sign in again.";

export function isAuthFailure(status, detail) {
  if (Number(status) === 401) return true;
  return false;
}

export function authFailureMessage(status, detail) {
  if (Number(status) === 401) return SESSION_EXPIRED_MESSAGE;
  const text = typeof detail === "string" ? detail.trim() : "";
  return text || SESSION_EXPIRED_MESSAGE;
}

export function clearClientSession() {
  try {
    if (typeof localStorage !== "undefined") localStorage.removeItem("apmercl_token");
  } catch {
    /* ignore quota / private-mode failures */
  }
  if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
    window.dispatchEvent(new CustomEvent("apmercl:session-expired"));
  }
}
